// test282
(282 && 0);
